import {useEffect, useState} from 'react';
import AuthCard from './components/AuthCard';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {showToastError, showToastSuccess} from './components/ToastNotifications';
import {useResetPasswordRecovery} from './hooks/usePasswordRecovery';

const invalidResetLinkMessage =
  'This password reset link is invalid or expired. Please request a new link.';
const resetFailureMessage =
  'Your password could not be created. Please try again, or submit a support ticket if the problem continues.';

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const {submit, pending} = useResetPasswordRecovery();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const email = searchParams.get('email')?.replace(/ /gi, '+') || '';
  const token = searchParams.get('token') || '';

  useEffect(() => {
    if (!email || !token) {
      //alert('Invalid password reset link. Please request a new one.');
      navigate('/forgot');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword)
      return showToastError('Your passwords do not match. Please try again.');

    if (password.length < 10)
      return showToastError('Password must be at least 10 characters long.');

    const result = await submit({password, email, token});

    if (result.kind === 'error') {
      return showToastError(result.thrown
        ? 'Your password could not be reset. Please try again.'
        : result.status === 400 ? invalidResetLinkMessage : resetFailureMessage);
    }
    if (result.kind === 'success') {
      showToastSuccess('Your new password has been created successfully.');
      navigate('/login');
    }
  };

  return (
    <AuthCard
      pageTestId="page-reset-password"
      cardTestId="reset-password-form"
      ariaLabel="Reset password"
      title="Reset Password"
      subtitle="Type your new password"
    >
      <form className="login-form" onSubmit={handleSubmit}>
        <label className="label">Password (10 characters)</label>
        <input
          type="password"
          className="input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={pending}
          data-testid="reset-password"
        />

        <label className="label">Confirm Password</label>
        <input
          type="password"
          className="input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={pending}
          data-testid="reset-password-confirm"
        />

        <button
          type="submit"
          className="button cta"
          style={{width: '100%', marginTop: 8}}
          data-testid="reset-password-submit"
          disabled={pending}
          aria-busy={pending}
        >
          {pending ? 'Changing Password…' : 'Change Password'}
        </button>
      </form>
    </AuthCard>
  );
}
